// Imports

// Utils
import { debug }     from '~/utils/debug';
import DOM           from '~/utils/dom';
import helper        from '~/utils/helper';
import measure       from '~/utils/measure';
import polyfill      from '~/utils/polyfill';
import query         from '~/utils/query';

// Core components
import anchor        from '~/components/anchor';
import scroll        from '~/components/scroll';
import svg           from '~/components/svg';

// Debug components
import grid          from '~/components/debug/grid';
import view          from '~/components/debug/view';

// Widget components
import konami        from '~/components/widgets/konami';

// Page components
import header        from '~/components/header.js';

// Vendor
import feather       from 'feather-icons';


// Init

let ms = new Date().getTime();
measure(window).type();

const _init = () => {
  measure(window).type(); // Detect and set viewport type

  // Logs Legend
  debug.log('LEGEND');
  debug.log('------');
  debug.log(':: Module');
  debug.log('~~ Async');
  debug.log('== User Action');
  debug.log('## API Request');
  debug.log('•• Complete');
  debug.log(' ');
  debug.log('APP');
  debug.log('------');

  // Polyfill init
  polyfill.init();

  // System init
  anchor.init();
  grid.init();
  helper.init();
  scroll.init();
  view.init();
  svg.init();

  // Widgets init
  konami.init();

  // Components init
  header.init();

  // Vendor init
  feather.replace({ class: 'icon' });

  // Window force init
  window.query = query;
};


// Deferred Run

const _defer = () => {
  document.body.classList.remove('preload');
  debug.log(`•• Matter in ${new Date().getTime() - ms} milliseconds`);
};


// Run

(function () { _init(); })();
DOM.when('load', window, _defer);
DOM.when('resize', window, () => { measure(window).type(); });
DOM.when('scroll', window, scroll.update);